import { ByLocales, Locales } from '@monoimin/sb-types';

export { pipedreamUrlsDict, analyticsFormIdDict } from './analytics';
export { enquiryFormDict, enquiryFormAnalyticsDict } from './EnquiryForm';
export { mediaInquiryFormDict } from './MediaInquiryForm';
export * from './quiz';
export * from './portugalD7Quiz';
export * from './uaeGoldenVisaQuiz';
export * from './FactsheetForm';

export { dueDiligenceFormDict } from './DueDiligence';

export const formInputsDict = {
  en: {
    characters: 'Characters',
    charactersLeft: 'Characters left',
    select: 'Please select',
  },
  ru: {
    characters: 'Символов',
    charactersLeft: 'Символов осталось',
    select: 'Пожалуйста выберите',
  },
  de: {
    characters: 'Charaktere',
    charactersLeft: 'Verbleibende Zeichen',
    select: 'Bitte auswählen',
  },
  tr: {
    characters: 'Karakterler',
    charactersLeft: 'Kalan karakterler',
    select: 'Lütfen seçin',
  },
  es: {
    characters: 'Caracteres',
    charactersLeft: 'Caracteres restantes',
    select: 'Por favor seleccione',
  },
};

export const gravityFormsDict = {
  en: {
    defaultButtonText: 'Submit',
    invalidEmail: 'Invalid email',
    invalidPhone: 'Invalid phone',
    enterValidPhone: 'Please enter a valid phone number',
    enterValidOption: 'Please select an option',
  },
  ru: {
    defaultButtonText: 'Отправить',
    invalidEmail: 'Неверный email',
    invalidPhone: 'Неверный телефон',
    enterValidPhone: 'Пожалуйста, введите правильный номер телефона',
    enterValidOption: 'Пожалуйста, выберите вариант',
  },
  de: {
    defaultButtonText: 'Einreichen',
    invalidEmail: 'Ungültige E-Mail',
    invalidPhone: 'Ungültige Telefonnummer',
    enterValidPhone: 'Bitte geben Sie eine gültige Telefonnummer ein',
    enterValidOption: 'Bitte wählen Sie eine Option',
  },
  tr: {
    defaultButtonText: 'Gönder',
    invalidEmail: 'Geçersiz e-posta',
    invalidPhone: 'Geçersiz telefon',
    enterValidPhone: 'Lütfen geçerli bir telefon numarası girin',
    enterValidOption: 'Lütfen bir seçenek seçin',
  },
  es: {
    defaultButtonText: 'Enviar',
    invalidEmail: 'Email no válido',
    invalidPhone: 'Teléfono no válido',
    enterValidPhone: 'Por favor, introduzca un número de teléfono válido',
    enterValidOption: 'Por favor, seleccione una opción',
  },
};

export const unsubscribeFormDict = {
  en: {
    title: 'Your subscription has been canceled.',
    description: 'Please, tell us the reasons:',
  },
  ru: {
    title: 'Ваша подписка отменена.',
    description: 'Расскажите, почему вы отписались:',
  },
  de: {
    title: 'Ihr Abonnement wurde gekündigt.',
    description: 'Bitte nennen Sie uns die Gründe:',
  },
  tr: {
    title: 'Aboneliğiniz iptal edildi.',
    description: 'Lütfen, nedenlerini bize belirtin:',
  },
  es: {
    title: 'Su suscripción ha sido cancelada.',
    description: 'Por favor, cuéntenos las razones:',
  },
};

export const inputDictionary: ByLocales<
  Locales,
  {
    required: string;
    phone: string;
    email: string;
    submit: string;
    submitLoading: string;
    submitSuccess: string;
    invalidPhone: string;
    submitError: string;
    maxLength: string;
    fileSize: string;
    fileType: string;
  }
> = {
  ru: {
    required: 'Это поле обязательно',
    phone: 'Неверный номер телефона',
    email: 'Неверный email',
    submit: 'Отправить',
    submitLoading: 'Обработка…',
    submitSuccess: 'Готово',
    invalidPhone: 'Неверный номер телефона',
    submitError:
      'Произошла ошибка при отправке вашего сообщения, попробуйте отправить форму еще раз',
    maxLength: 'Максимальная длина 500 символов',
    fileSize: 'Размер файла превышает 30MB',
    fileType: 'Неверный тип файла',
  },
  en: {
    required: 'This field is required',
    phone: 'Invalid phone number',
    email: 'Invalid email',
    submit: 'Submit',
    submitLoading: 'Processing…',
    submitSuccess: 'Done',
    invalidPhone: 'Invalid phone number',
    submitError:
      'An error occurred while sending your message, please try submitting the form again',
    maxLength: 'Maximum length 500 characters',
    fileSize: 'File size exceeds 30MB',
    fileType: 'Invalid file type',
  },
  tr: {
    required: 'Bu alan zorunludur',
    phone: 'Geçersiz telefon numarası',
    email: 'Geçersiz email',
    submit: 'Gönder',
    submitLoading: 'İşleniyor…',
    submitSuccess: 'Tamamlandı',
    invalidPhone: 'Geçersiz telefon numarası',
    submitError:
      'Mesajınız gönderilirken bir hata oluştu, lütfen formu tekrar göndermeyi deneyin',
    maxLength: 'Maksimum 500 karakter',
    fileSize: "Dosya boyutu 30MB'ı aşıyor",
    fileType: 'Geçersiz dosya türü',
  },
  de: {
    required: 'Dieses Feld ist erforderlich',
    phone: 'Ungültige Telefonnummer',
    email: 'Ungültige Email',
    submit: 'Senden',
    submitLoading: 'Wird verarbeitet…',
    submitSuccess: 'Erfolgreich gesendet',
    invalidPhone: 'Ungültige Telefonnummer',
    submitError:
      'Beim Senden Ihrer Nachricht ist ein Fehler aufgetreten, bitte versuchen Sie es erneut',
    maxLength: 'Maximal 500 Zeichen',
    fileSize: 'Dateigröße überschreitet 5MB',
    fileType: 'Ungültiger Dateityp',
  },
  es: {
    required: 'Este campo es obligatorio',
    phone: 'Número de teléfono no válido',
    email: 'Email no válido',
    submit: 'Enviar',
    submitLoading: 'Procesando…',
    submitSuccess: 'Hecho',
    invalidPhone: 'Número de teléfono no válido',
    submitError:
      'Se produjo un error al enviar su mensaje, intente enviar el formulario nuevamente',
    maxLength: 'Longitud máxima 500 caracteres',
    fileSize: 'El tamaño del archivo excede 30MB',
    fileType: 'Tipo de archivo no válido',
  },
};
